import React from 'react';
import { IDialog } from './interface';
import {
  AppBar,
  CustomTheme,
  DialogActions,
  DialogContent,
  IconButton,
  Dialog as MuiDialog,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const Dialog: React.FC<IDialog> = ({
  title,
  show,
  disableClose = false,
  buttons,
  children,
  onClose,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  return (
    <MuiDialog
      fullScreen={fullScreen}
      open={show}
      keepMounted={false}
      //   TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            disabled={disableClose}
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent
        dividers={true}
        sx={{
          minWidth: fullScreen ? undefined : '400px',
        }}
      >
        {children}
      </DialogContent>
      {buttons && <DialogActions>{buttons}</DialogActions>}
    </MuiDialog>
  );
};
